import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LanguageInterceptor } from './language.interceptor';
import { SmartNavigatorModule } from '@ui-tool/core';

@NgModule({
  imports: [SmartNavigatorModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: LanguageInterceptor,
    },
  ],
})
export class LanguageModule {}
